/*
 * Clerk x Shopify Markets — Correct Price Display
 * Fetches the real market price from Shopify and injects it into Clerk cards.
 * Edit CONFIG.designs to match your Clerk design selectors.
 */
(function () {
  'use strict';

  // ============================================================
  // CONFIG — edit this per client. One entry per Clerk design.
  // ============================================================
  var CONFIG = {
    productLinkSelector: 'a[href*="/products/"]',
    designs: [
      {
        // Design 1 — Omnisearch ID 318716
        cardSelector: '.os-grid-item.os-grid-product.clerk-product-card',
        regularPriceSelector: '.clerk-product-price__current',
        originalPriceSelector: '.clerk-product-price__original',
        salePriceSelector: '.clerk-product-price__sale'
      }
      ,{
        // Design 2 - Recommendations ID 318715
        cardSelector: '.clerk-product-card',
        regularPriceSelector: '.clerk-product-price__current',
        originalPriceSelector: '.clerk-product-price__original',
        salePriceSelector: '.clerk-product-price__sale'
      }
      ,{
        // Design 3 - Cart ID 327533
        cardSelector: '.clerk-cart-drawer__slider-item',
        regularPriceSelector: '.clerk-cart-drawer__price',
        originalPriceSelector: '.clerk-cart-drawer__list-price'
      }
    ]
  };
  // ============================================================

  var _priceCache = {};
  var _fmtCache = {};

  function getFormatter(currency) {
    if (!(currency in _fmtCache)) {
      try {
        _fmtCache[currency] = new Intl.NumberFormat(navigator.language || 'en', {
          style: 'currency', currency: currency
        });
      } catch (e) {
        _fmtCache[currency] = null;
      }
    }
    return _fmtCache[currency];
  }

  function fmt(priceCents, currency) {
    var f = getFormatter(currency);
    return f ? f.format(priceCents / 100) : (priceCents / 100).toFixed(2) + '\u00a0' + currency;
  }

function updateCard(card, design, data, currency) {
  var sale = design.salePriceSelector
    ? card.querySelector(design.salePriceSelector)
    : null;
  var current = card.querySelector(design.regularPriceSelector);
  var original = design.originalPriceSelector
    ? card.querySelector(design.originalPriceSelector)
    : null;

  var nowPrice = sale || current;
  if (nowPrice) {
    (nowPrice.querySelector('p') || nowPrice).textContent =
      fmt(data.price, currency);
  }

  if (original && data.compare_at_price) {
    (original.querySelector('p') || original).textContent =
      fmt(data.compare_at_price, currency);
  }
}

  function hydrateDesign(design, currency) {
    var linkSel = design.productLinkSelector || CONFIG.productLinkSelector;
    var cards = document.querySelectorAll(design.cardSelector);

    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        if (card.getAttribute('data-clerk-price-done') === currency) return;

        var link = card.querySelector(linkSel);
        if (!link) return;

        var m = (link.getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
        if (!m) return;

        var handle = m[1];
        var key = handle + '_' + currency;

        function apply(data) {
          updateCard(card, design, data, currency);
          card.setAttribute('data-clerk-price-done', currency);
        }

        if (_priceCache[key]) { apply(_priceCache[key]); return; }

        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var data = { price: d.price, compare_at_price: d.compare_at_price };
            _priceCache[key] = data;
            apply(data);
          })
          .catch(function () {});
      })(cards[i]);
    }
  }

  function hydrate() {
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!currency) return;
    for (var d = 0; d < CONFIG.designs.length; d++) {
      hydrateDesign(CONFIG.designs[d], currency);
    }
  }

  var _scheduled = false;
  function scheduleHydrate() {
    if (_scheduled) return;
    _scheduled = true;
    setTimeout(function () { _scheduled = false; hydrate(); }, 50);
  }


  function observe() {
    hydrate();
    var obs = new MutationObserver(scheduleHydrate);
    obs.observe(document.body, { childList: true, subtree: true });
    if (typeof Clerk === 'function') Clerk('on', 'rendered', hydrate);
  }

  if (document.body) {
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', observe);
  }
})();